import { ActionTypes, Actions } from '@appStore/contracts/actions';

export interface State {
    additionAgreementCreated: boolean;
    createAdditionAgreementLoading: boolean;
    createAdditionAgreementLoaded: boolean;
    createAdditionAgreementId: number;
    activeAgreementLink: string;
    activeAgreementLinkLoading: boolean;
    activeAgreementLinkLoaded: boolean;
    isAdditionAgreementCreated: boolean;
    isAdditionAgreementCreatedLoaded: boolean;
    isAdditionAgreementCreatedLoading: boolean;
}

export const initialState: State = {
    additionAgreementCreated: false,
    createAdditionAgreementLoading: false,
    createAdditionAgreementLoaded: false,
    createAdditionAgreementId: null,
    activeAgreementLink: null,
    activeAgreementLinkLoading: false,
    activeAgreementLinkLoaded: false,
    isAdditionAgreementCreated: false,
    isAdditionAgreementCreatedLoaded: false,
    isAdditionAgreementCreatedLoading: false,
}

export function reducer(state = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypes.CreateAdditionAgreement:
            return {...state, additionAgreementCreated: false, createAdditionAgreementLoading: true, createAdditionAgreementLoaded: false, createAdditionAgreementId: null };
        case ActionTypes.CreateAdditionAgreementSuccess:
            return {...state, 
                additionAgreementCreated: true, 
                createAdditionAgreementLoading: false, 
                createAdditionAgreementLoaded: true, 
                createAdditionAgreementId: action.payload,
                activeAgreementLink: null,
                activeAgreementLinkLoaded: false,
                activeAgreementLinkLoading: false 
            };
        case ActionTypes.CreateAdditionAgreementFail:
            return {...state, additionAgreementCreated: false, createAdditionAgreementLoading: false, createAdditionAgreementLoaded: false, createAdditionAgreementId: null };
        case ActionTypes.AgreementLinkLoad:
            return {...state, activeAgreementLink: null, activeAgreementLinkLoaded: false, activeAgreementLinkLoading: true };
        case ActionTypes.AgreementLinkLoadSuccess:
            return {...state, activeAgreementLink: action.payload, activeAgreementLinkLoaded: true, activeAgreementLinkLoading: false };
        case ActionTypes.AgreementLinkLoadFail:
            return {...state, activeAgreementLink: null, activeAgreementLinkLoaded: false, activeAgreementLinkLoading: false };

        case ActionTypes.IsAdditionAgreementCreated:
            return {...state, isAdditionAgreementCreated: false, isAdditionAgreementCreatedLoaded: false, isAdditionAgreementCreatedLoading: true };
        case ActionTypes.IsAdditionAgreementCreatedSuccess:
            return {...state, isAdditionAgreementCreated: action.payload, isAdditionAgreementCreatedLoaded: true, isAdditionAgreementCreatedLoading: false };
        case ActionTypes.IsAdditionAgreementCreatedFail:
            return {...state, isAdditionAgreementCreated: false, isAdditionAgreementCreatedLoaded: false, isAdditionAgreementCreatedLoading: false };

        case ActionTypes.ClearCreateAdditionAgreementState:
            return {...state, 
                additionAgreementCreated: false, 
                createAdditionAgreementLoading: false, 
                createAdditionAgreementLoaded: false, 
                createAdditionAgreementId: null,
                activeAgreementLink: null,
                activeAgreementLinkLoaded: false,
                activeAgreementLinkLoading: false 
            };
    }

    return state;
}

export const _getAdditionAgreementCreated = (state: State) => state.additionAgreementCreated;
export const _getAdditionAgreementCreateId = (state: State) => state.createAdditionAgreementId;
export const _getActiveAgreementLink = (state: State) => state.activeAgreementLink;
export const _getActiveAgreementLinkLoaded = (state: State) => state.activeAgreementLinkLoaded;

export const _getIsAdditionAgreementCreated = (state: State) => state.isAdditionAgreementCreated;
export const _getIsAdditionAgreementCreatedLoaded = (state: State) => state.isAdditionAgreementCreatedLoaded;